import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import TextAreaField from "../../Shared/TextAreaField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const SendUnpaidMessageForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [categoryOptions, setCategoryOptions] = useState([])

    const [formData, setFormData] = useState({
        employee_id: "",
        category_id: "",
        year: "",
        month: "",
        message: "",
        by: "",
        char_counter: 0,
        sms_counter: 1,
    })
    const {employee_id, category_id, year, month, message, by, char_counter, sms_counter} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state){
            const { payload } = location.state
            setFormData((prev) => ({
                ...prev,
                employee_id: payload.employee_id,
                by: payload.by,
                year: payload.year,
                month: payload.month,
            }))
        }
                
    }, []);

    const loadOptions = async (url, query, setOptions) => {
        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const isBody = name === "message";
            const newBody = isBody ? value : prev.message;
            const charDiff = isBody ? newBody.length - prev.message.length : 0;
            return {
                ...prev,
                [name]: value,
                char_counter: isBody ? Math.max(0, prev.char_counter + charDiff) : prev.char_counter,
                sms_counter: isBody ? Math.ceil(newBody.length / 160) : prev.sms_counter,
            }
        })
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {employee_id, category_id, message, year, month}
        sendMessage(payload)
    }
    
    const sendMessage = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post(`/messages/message-${by}-unpaid`, payload)
            if (response.status === 200){
                toast.success(response?.data?.detail)
                navigate(`/un-paid`)
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Send Message Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <AsyncSelectField
                                name="category_id"
                                label="Category"
                                value={category_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('message-categories', query, setCategoryOptions)}
                                options={categoryOptions}
                                placeholder="Start typing to search..."
                                error={errors.category_id}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <TextAreaField
                                placeholder="Message"
                                name="message"
                                type="text"
                                label="Message"
                                required="required"
                                value={message}
                                onChange={onChange}
                                error={errors.message}
                            />
                            <span className="text-orange h3" style={{float: 'right', marginRight: '20px'}}>{`Characters: ${char_counter}, SMS: ${sms_counter}`}</span>
                        </div>
                        
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Send Message" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default SendUnpaidMessageForm
